module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cons_item_block"
  }, [_c('div', {
    staticClass: "cons_item_block_header",
    class: {
      padding_bottom: _vm.open
    }
  }, [_c('p', {
    staticClass: "cons_item_data bold",
    class: {
      blue: !_vm.open
    },
    on: {
      "click": function($event) {
        _vm.open = true
      }
    }
  }, [_vm._v(_vm._s(_vm.header))]), (_vm.open) ? _c('p', {
    staticClass: "blue cons_item_data bold",
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }, [_vm._v("Свернуть")]) : _vm._e()]), (_vm.open) ? _c('div', {
    staticClass: "cons_item_block_body cons_item_data"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8671554","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/consultations/components/ConsultationItemBlock.vue
// module id = 7850d2c6f39040553c0a
// module chunks = 89